import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PlatformPageHero = ({ eyebrow, title, body }) => (
  <header className="bg-gradient-to-br from-paper-100 to-brand-50 border-b border-paper-300">
    <div className="max-w-7xl mx-auto px-6 py-20 md:py-28">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-subtle hover:text-brand-700 mb-12">
        <ArrowLeft size={15} /> Home
      </Link>
      <p className="text-xs font-semibold tracking-widest text-brand-700 uppercase mb-4">{eyebrow}</p>
      <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-ink max-w-4xl leading-[1.04]">{title}</h1>
      <p className="mt-6 text-lg md:text-xl text-ink-muted max-w-3xl leading-relaxed">{body}</p>
    </div>
  </header>
);

export default PlatformPageHero;
